import * as React from 'react';

import { Button, Dialog } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type EmailInviteModalProps = {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  /** Set when the group step should be skipped — consumed once this flow is built out (Task 2/5). */
  autoSelectedGroupId?: string;
};

/**
 * Placeholder for the email/manual invite flow (ENTADMIN-1951 scaffolding only).
 * Replaced by the real row-based invitee form in a later Phase A task.
 */
const EmailInviteModal = ({ open, onClose, onBack, autoSelectedGroupId }: EmailInviteModalProps) => (
  <Dialog open={open} onClose={onClose}>
    <HeadingGroup>{_t('Add learners via email')}</HeadingGroup>
    <Content>{autoSelectedGroupId && <span data-testid="auto-selected-group-id">{autoSelectedGroupId}</span>}</Content>
    <Actions>
      <Button variant="secondary" onClick={onBack}>
        {_t('Back')}
      </Button>
    </Actions>
  </Dialog>
);

export default EmailInviteModal;
